module.exports = __webpack_public_path__ + "img/logo-white.1092570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/logo-white.png
// module id = tbHR
// module chunks = 3 5